<template>
  <div class="ta-r">
    <el-pagination
      @current-change="onPageChange"
      class="mt-10 d-ib"
      background
      layout="prev,total,sizes, pager, next"
      :total="params.total"
      :page-sizes="[20, 30, 50, 80, 100, 150]"
      :page-size="params.pageSize"
      @size-change="onSizeChange"
      @prev-click="prevClick"
      @next-click="nextClick"
    ></el-pagination> 
  </div>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  methods: {
    onPageChange(v) {
      this.params.pageNum = v
      this.$emit('getList')
    },
    onSizeChange(v) {
      this.params.pageSize = v
      this.params.pageNum = 1
      this.$emit('getList')
    },
    prevClick(v) {
      this.params.pageNum = v
      this.$emit('getList')
    },
    nextClick() {
      this.params.pageNum = v
      this.$emit('getList')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Util/PageUtil.vue